var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDiagnose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 160,
    viewBox: "0 0 200 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "wbzvzxfy0a",
    d: "M0 0.063L39.589 0.063 39.589 43.309 0 43.309z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2899ok95jc",
    d: "M0 137.19L112.958 137.19 112.958 0 0 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H200V160H0z",
    transform: "translate(-992 -877) translate(32 22) translate(960 855)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.694,
    transform: "translate(-992 -877) translate(32 22) translate(960 855) translate(39 11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 89.271)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8j31so31zb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wbzvzxfy0a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CDE0FB",
    d: "M1.572 3.048c3.002-5.689 12.8-1.498 12.8-1.498s4.558 12.162 6.52 12.868c1.963.707-1.867-11.159-1.867-11.159 3.998.501 12.89 7.538 12.89 7.538s-3.411 12.227-1.335 12.428c2.076.202 2.468-10.98 2.468-10.98 3.53 1.987 6.072 7.199 6.072 7.199 2.8 8.187-7.857 11.36-7.857 11.36s-1.091 4.262.453 9.78c0 0 .394 1.043.654 2.725l-1.032-.232c-.022-.296-.055-.584-.1-.864v-.005l-.003-.013c-.035-.175-.085-.425-.15-.73v-.002c-.177-.689-.288-1.193-.348-1.552v-.003c-.51-2.15-1.303-4.982-2.092-5.715 0 0 .15-.135.327-.424l-.327.424c-2.618 3.389-11.595 2.034-16.29-.083-4.695-2.116-2.237-3.022.92-4.679 3.156-1.657 8.576.185 10.415-.33 1.84-.514-.36-1.937-3.698-2.422-3.338-.485-5.716 2.427-11.13 1.74-5.415-.686-7.212-11.564-7.212-11.564 3.405 1.958 10.421 1.414 10.957.209.537-1.206-9.21-3.264-10.64-3.983-1.428-.72-3.398-4.344-.395-10.033",
    mask: "url(#8j31so31zb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AFCDFB",
    d: "M16.575 0S3.91-.618 10.629 37.977c0 0 4.52 13.1-1.186 21.545h83.982V0h-76.85z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "kl0lovp5ad",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2899ok95jc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9ABCEF",
    d: "M21.9 137.19L109.579 137.19 109.579 22.845 21.9 22.845z",
    mask: "url(#kl0lovp5ad)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9F3FE",
    d: "M24.766 137.19L110.971 137.19 110.971 22.845 24.766 22.845z",
    mask: "url(#kl0lovp5ad)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M33.496 131.851L104.188 131.851 104.188 30.124 33.496 30.124z",
    mask: "url(#kl0lovp5ad)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D8E8FD",
    d: "M33.496 131.851L104.188 131.851 104.188 30.124 33.496 30.124z",
    mask: "url(#kl0lovp5ad)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F99746",
    d: "M51.625 40.957L83.847 40.957 83.847 39.284 51.625 39.284zM47.46 44.84L63.571 44.84 63.571 43.167 47.46 43.167zM65.515 44.84L89.161 44.84 89.161 43.167 65.515 43.167z",
    mask: "url(#kl0lovp5ad)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEC3FF",
    d: "M49.193 82.126L83.957 82.126 83.957 80.852 49.193 80.852zM67.525 78.727L92.142 78.727 92.142 77.453 67.525 77.453zM41.009 78.727L64.989 78.727 64.989 77.453 41.009 77.453zM68.554 75.328L89.731 75.328 89.731 74.055 68.554 74.055zM43.42 75.328L64.597 75.328 64.597 74.055 43.42 74.055z",
    mask: "url(#kl0lovp5ad)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8C3F7",
    d: "M72.249 93.415H62.027c-.464 0-.844-.38-.844-.843 0-.464.38-.843.844-.843h10.222c.464 0 .843.38.843.843 0 .464-.38.843-.843.843M86.51 93.415H76.286c-.464 0-.844-.38-.844-.843 0-.464.38-.843.844-.843h10.222c.464 0 .843.38.843.843 0 .464-.38.843-.843.843M74.023 97.857c-4.822 0-8.745 3.923-8.745 8.745 0 4.822 3.923 8.745 8.745 8.745 4.822 0 8.745-3.923 8.745-8.745 0-4.822-3.923-8.745-8.745-8.745m0 17.954c-5.078 0-9.209-4.131-9.209-9.209 0-5.078 4.131-9.209 9.21-9.209 5.077 0 9.208 4.131 9.208 9.21 0 5.077-4.131 9.208-9.209 9.208",
    mask: "url(#kl0lovp5ad)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8C3F7",
    d: "M74.023 99.646c-3.835 0-6.956 3.12-6.956 6.956 0 3.836 3.12 6.956 6.956 6.956 3.836 0 6.956-3.12 6.956-6.956 0-3.835-3.12-6.956-6.956-6.956m0 14.377c-4.091 0-7.42-3.33-7.42-7.42 0-4.092 3.329-7.421 7.42-7.421 4.092 0 7.42 3.329 7.42 7.42 0 4.092-3.328 7.42-7.42 7.42",
    mask: "url(#kl0lovp5ad)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8C3F7",
    d: "M76.28 103.666c-.026.074-.05.179-.07.303.035-.12.06-.223.07-.303m-2.809 1.67c-.073.153-.126.645-.036 1.082.145-.48.174-.894.036-1.082m1.7.372c.045.136.085.162.085.163.162-.14.347-.44.515-.783-.137-.006-.292-.006-.46-.002-.024.193-.073.407-.14.622m-1.578 1.139c.062.094.145.168.255.173.22.01.483-.224.722-.643.124-.218.224-.45.299-.674-.049-.182-.074-.394-.082-.589-.32.026-.67.07-1.03.135.187.365.078.983-.164 1.598m-2.662-.475c.152 1.015.66 1.761 1.092 1.896.202.063.389-.009.553-.212.281-.347.524-.775.698-1.192-.05-.108-.09-.234-.12-.378-.07-.334-.082-.794 0-1.109-.465.115-.932.27-1.365.475-.33.157-.617.33-.858.52m3.19 3.14c-.964.313-1.904.476-2.644.415-1.127-.094-1.761-.685-1.786-1.663-.02-.777.302-1.457.933-2.008l-.015-.159c-.041-.547.076-.911.348-1.08.44-.275 1.094.1 1.121.116l-.146.25c-.146-.085-.582-.273-.822-.121-.208.13-.233.488-.215.779.514-.372 1.186-.676 2.004-.897.605-.164 1.28-.273 1.889-.322.003-.068.008-.13.016-.18.02-.134.066-.291.198-.322.05-.011.148-.01.234.122.055.084.083.206.089.351.21-.005.404 0 .577.012l.005-.011c-.042-.343-.013-.747.044-1.008.074-.336.194-.505.362-.521.102-.01.19.045.23.142.094.227-.083.84-.339 1.43l.001.003c.24.04.403.107.454.2.039.07.044.178-.058.271-.194.179-.349.134-.423.091-.064-.036-.115-.098-.156-.177-.193.383-.404.71-.57.85-.153.128-.287.076-.337.048-.026-.015-.05-.034-.073-.058-.066.16-.14.315-.22.456-.304.531-.645.805-.987.788-.14-.006-.265-.062-.37-.163-.189.41-.427.8-.663 1.092-.241.297-.548.406-.865.306-.562-.175-1.07-.987-1.26-1.95-.48.47-.713 1.025-.697 1.662.021.835.533 1.3 1.521 1.382 2.494.208 6.867-2.11 7.198-3.817-.27 1.388-2.344 2.968-4.578 3.692",
    mask: "url(#kl0lovp5ad)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEC3FF",
    d: "M47.167 66.652L85.984 66.652 85.984 65.379 47.167 65.379zM67.636 63.254L95.123 63.254 95.123 61.98 67.636 61.98zM38.028 63.254L64.804 63.254 64.804 61.98 38.028 61.98zM68.785 59.855L92.431 59.855 92.431 58.581 68.785 58.581zM40.72 59.855L64.366 59.855 64.366 58.581 40.72 58.581z",
    mask: "url(#kl0lovp5ad)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9F3FE",
    d: "M110.972 22.843v.002H24.765c.477-6.52-.241-11.253-1.393-14.657C21.163 1.643 17.353 0 17.353 0h81.299c6.939 0 12.32 4.18 13.784 9.73.054.208.105.416.15.624 1.39 6.348-1.557 12.373-1.614 12.49",
    mask: "url(#kl0lovp5ad)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8E8FD",
    d: "M110.972 22.843v.002H24.765c.477-6.52-.241-11.253-1.393-14.657 8.81 1.613 30.63 5.05 53.984 4.472 15.11-.375 27.05-1.386 35.228-2.306 1.39 6.348-1.556 12.373-1.613 12.49",
    mask: "url(#kl0lovp5ad)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDiagnose);
export default __webpack_public_path__ + "static/media/no-diagnose.c858850b2917388df2282ce394061baa.svg";
export { ForwardRef as ReactComponent };